import React from 'react';
import Icon from '../../components/AppIcon';
import Button from '../ui/Button';
import Input from '../ui/Input';

/**
 * Interview filters component for filtering and sorting interviews
 */
const InterviewFilters = ({ 
  filters, 
  onFilterChange, 
  onClearFilters, 
  hasActiveFilters,
  viewMode,
  setViewMode,
  isSidebar = false
}) => {
  return (
    <div className={`mb-6 p-4 bg-white border border-border rounded-lg ${
      isSidebar ? 'sticky top-0' : ''
    }`}>
      <div className="flex justify-between items-center mb-4">
        <h2 className="font-semibold text-lg text-text-primary">Filter By</h2>
      </div>
      
      {/* Search Box */}
      <div>
        <label htmlFor="searchQuery" className="block text-sm font-medium text-text-secondary mb-1">
          Search Candidates
        </label>
        <div className="relative">
          <Input
            id="searchQuery"
            type="text"
            placeholder="Search by name, job title, etc."
            value={filters.searchQuery}
            onChange={(e) => onFilterChange('searchQuery', e.target.value)}
            className="w-full pr-10 mb-4"
          />
          <div className="absolute right-3 top-1/2 transform -translate-y-1/2">
            <Icon name="Search" size={18} className="text-text-secondary" />
          </div>
        </div>
      </div>

      {/* List & Grid Mode */}
      <div className="flex items-start gap-2">
              <div className="text-sm text-text-secondary">
                View as:
              </div>
              <div className="flex items-center gap-1">
                <button
                  onClick={() => setViewMode('grid')}
                  className={`p-1.5 flex items-center gap-1 rounded ${viewMode === 'grid' ? 'bg-primary-50 text-primary' : 'hover:bg-background'}`}
                  aria-label="Grid view"
                >
                  <Icon name="Grid" size={16} />
                  {isSidebar && <span className="text-xs">Grid</span>}
                </button>
                <button
                  onClick={() => setViewMode('list')}
                  className={`p-1.5 flex items-center gap-1 rounded ${viewMode === 'list' ? 'bg-primary-50 text-primary' : 'hover:bg-background'}`}
                  aria-label="List view"
                >
                  <Icon name="List" size={16} />
                  {isSidebar && <span className="text-xs">List</span>}
                </button>
              </div>
            </div>

      {/* Filter fields */}
      <div className={`grid gap-4 mb-4 ${
        isSidebar ? 'grid-cols-1' : 'grid-cols-1 sm:grid-cols-2 lg:grid-cols-3'
      }`}>
        {/* Date Range Filter */}
        <div>
          <label htmlFor="dateRange" className="block text-sm font-medium text-text-secondary mb-1">
            Date Range
          </label>
          <select
            id="dateRange"
            value={filters.dateRange}
            onChange={(e) => onFilterChange('dateRange', e.target.value)}
            className="w-full border border-border rounded-md px-3 py-2 text-sm focus:outline-none focus:ring-2 focus:ring-primary focus:border-primary"
          >
            <option value="all">All Dates</option>
            <option value="today">Today</option>
            <option value="tomorrow">Tomorrow</option>
            <option value="this_week">This Week</option>
            <option value="next_week">Next Week</option>
            <option value="this_month">This Month</option>
            <option value="past">Past Interviews</option>
          </select>
        </div>
        
        {/* Status Filter */}
        <div>
          <label htmlFor="hiringStatus" className="block text-sm font-medium text-text-secondary mb-1">
            Hiring Status
          </label>
          <select
            id="hiringStatus"
            value={filters.hiringStatus}
            onChange={(e) => onFilterChange('hiringStatus', e.target.value)}
            className="w-full border border-border rounded-md px-3 py-2 text-sm focus:outline-none focus:ring-2 focus:ring-primary focus:border-primary"
          >
            <option value="all">All Statuses</option>
            <option value="interviewed">Interviewed</option>
            <option value="under_consideration">Under Consideration</option>
            <option value="hired">Hired</option>
            <option value="not_moving_forward">Not Moving Forward</option>
          </select>
        </div>
      
        {/* Filter actions */}
        <div className="flex w-full items-end">
          
          <div className="flex items-center gap-3">
            <div className="flex items-start flex-col gap-1">
              <div className="text-sm text-text-secondary">
                Sort by:
              </div>
              <select
                value={filters.sortBy}
                onChange={(e) => onFilterChange('sortBy', e.target.value)}
                className="border border-border rounded-md px-2 py-1 text-sm focus:outline-none focus:ring-2 focus:ring-primary focus:border-primary"
              >
                <option value="date_desc">Date (Newest First)</option>
                <option value="date_asc">Date (Oldest First)</option>
                <option value="name_asc">Candidate Name (A-Z)</option>
                <option value="name_desc">Candidate Name (Z-A)</option>
              </select>
            </div>
          </div>
          <div>
            {hasActiveFilters && (
              <Button
                variant="ghost"
                size="sm"
                onClick={onClearFilters}
                className="text-text-secondary hover:text-primary flex items-center gap-1"
              >
                <Icon name="X" size={14} />
                <span>Clear filters</span>
              </Button>
            )}
          </div>
        </div>
      </div>
    </div>
  );
};

export default InterviewFilters;